import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageHeader } from '@ems/ui/patterns/page-header'

import { ReadOnlyNotice } from '#admin/components/read-only-notice.tsx'
import { sessionQuery } from '#admin/features/auth/queries.ts'
import { can } from '#admin/features/auth/session.ts'
import { CompaniesTable } from '#admin/features/exhibitor/companies-table.tsx'
import { ApplicationsSkeleton } from '#admin/features/exhibitor/exhibitor-skeletons.tsx'
import { companiesQuery } from '#admin/features/exhibitor/queries.ts'

/** `/exhibition/companies` — the exhibitor companies. A row opens the members of the company. */
export const Route = createFileRoute('/_authenticated/exhibition/companies/')({
  // ponytail: the applications skeleton has the same shape (a header and a table).
  pendingComponent: ApplicationsSkeleton,
  loader: ({ context }) => context.queryClient.ensureQueryData(companiesQuery()),
  component: CompaniesPage,
})

function CompaniesPage() {
  const { data } = useSuspenseQuery(companiesQuery())
  const { data: session } = useSuspenseQuery(sessionQuery())
  // A view-only role sees the list and no verbs. The server refuses them anyway.
  const canManage = can(session, 'exhibitor.manage')

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Companies"
        description="The exhibitor companies. The members of a company apply for stands and order services in the portal."
      />

      {canManage ? null : <ReadOnlyNotice area="the company list" />}

      <CompaniesTable companies={data.items} canManage={canManage} />
    </div>
  )
}
